"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _ = require("../..");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["moment", "momentLink", "toast", "onDownload", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var hashtags = "TraceMoments";
/**
 * A DropDownMenu preconfigured with options and handlers
 * for sharing a moment.
 */

var ShareMenu = function ShareMenu(_ref) {
  var moment = _ref.moment,
      momentLink = _ref.momentLink,
      toast = _ref.toast,
      onDownload = _ref.onDownload,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouter.useHistory)();
  var token = (0, _.useToken)("ShareMenu");
  var shareOptions = [{
    title: "Copy link",
    value: "copy",
    iconType: _.Icon.Type.Link
  }, {
    title: "Download",
    value: "download",
    iconType: _.Icon.Type.Download
  }, {
    title: "Facebook",
    value: "facebook",
    iconType: _.Icon.Type.Facebook
  }, {
    title: "Twitter",
    value: "twitter",
    iconType: _.Icon.Type.Twitter
  }, {
    title: "Email",
    value: "email",
    iconType: _.Icon.Type.Email
  }];

  var onChange = function onChange(e, value) {
    console.log("ShareMenu onChange", e);

    switch (value) {
      case "copy":
        handleCopyLink(e);
        break;

      case "download":
        handleDownload(e);
        break;

      case "facebook":
        handleFacebookShare(e);
        break;

      case "twitter":
        handleTwitterShare(e);
        break;

      case "email":
        handleSendEmail(e);
        break;

      default:
        console.warn("ShareMenu onChange unknown value", value);
    }
  };

  var handleDownload = function handleDownload() {
    if (typeof onDownload === "function") {
      onDownload();
    } else {
      history.push("".concat(history.location.pathname, "/download"));
    }
  };

  var handleSendEmail = function handleSendEmail(e) {
    var subject = "Watch this moment from Trace";
    var body = "Hi, check out this moment on Trace.";
    body += "\n";
    body += "\n";
    body += momentLink + "&utm_campaign=trace_id_plus";
    var encBody = encodeURIComponent(body);
    var link = "mailto:?BCC=sharingiscaring@traceup.com&Subject=".concat(subject, "&Body=").concat(encBody);
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href: link
    }).click();
    (0, _.trackEvent)({
      action: "Send Email Pressed",
      label: "Share Button",
      element: e.target
    });

    if (moment && moment.game_clip_id) {
      (0, _.sharedMomentToCZ)({
        type: "email",
        user_id: token === null || token === void 0 ? void 0 : token.user_id,
        where: "traceid",
        moment_id: moment.game_clip_id
      });
    }
  };

  var handleFacebookShare = function handleFacebookShare(e) {
    var text = "Watch this moment from Trace";
    var url = "https://facebook.com/sharer.php?display=popup&u=".concat(momentLink, "&quote=").concat(text, "&hashtag=%23").concat(hashtags);
    window.open(url, text, "width=600,height=400");
    (0, _.trackEvent)({
      action: "Facebook Pressed",
      label: "Share Button",
      element: e.target
    });

    if (moment && moment.game_clip_id) {
      (0, _.sharedMomentToCZ)({
        type: "facebook",
        user_id: token === null || token === void 0 ? void 0 : token.user_id,
        where: "traceid",
        moment_id: moment.game_clip_id
      });
    }
  };

  var handleTwitterShare = function handleTwitterShare(e) {
    var text = "Watch this moment from Trace";
    var twitterLink = "https://twitter.com/intent/tweet?url=".concat(momentLink, "&text=").concat(text, "&hashtags=").concat(hashtags);
    window.open(twitterLink, text, "width=600,height=400");
    (0, _.trackEvent)({
      action: "Twitter Pressed",
      label: "Share Button",
      element: e.target
    });

    if (moment && moment.game_clip_id) {
      (0, _.sharedMomentToCZ)({
        type: "twitter",
        user_id: token === null || token === void 0 ? void 0 : token.user_id,
        where: "traceid",
        moment_id: moment.game_clip_id
      });
    }
  };

  var handleCopyLink = function handleCopyLink(e) {
    copyURLToClipbard(e, "share-menu-copy-link");
    (0, _.trackEvent)({
      action: "Copy Link Pressed",
      label: "Share Button",
      element: e.target
    });

    if (typeof toast === "function") {
      dispatch(toast("Link copied to clipboard"));
    }
  };

  return /*#__PURE__*/_react.default.createElement(_.Element, _extends({}, props, {
    className: "ShareMenu"
  }), /*#__PURE__*/_react.default.createElement("textarea", {
    id: "share-menu-copy-link",
    style: {
      height: "1px",
      left: "-999px",
      position: "absolute",
      top: "-999px",
      width: "1px"
    },
    readOnly: true,
    value: momentLink
  }), /*#__PURE__*/_react.default.createElement(_.DropdownMenu, {
    title: "Share",
    menuPortal: "#modal-root",
    options: shareOptions,
    onChange: onChange,
    menuDirection: "right",
    offsetAxisX: 16,
    classNameMenu: "small-share-button-dropdown",
    button: children
  }));
};

exports.ShareMenu = ShareMenu;
ShareMenu.propTypes = {
  moment: _propTypes.default.object.isRequired,
  momentLink: _propTypes.default.string.isRequired,
  toast: _propTypes.default.func
};

var copyURLToClipbard = function copyURLToClipbard(e) {
  var textAreaId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "copy-link";
  // trackEvent('Share Dialog', 'Copy Link Pressed', 'Button')
  var el = document.getElementById(textAreaId);
  el.contentEditable = true;
  el.readOnly = true;
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range); // Does not work for Firefox if a textarea or input

  if (el.nodeName === "TEXTAREA" || el.nodeName === "INPUT") el.select(); // Firefox will only select a form element with select()

  if (el.setSelectionRange && navigator.userAgent.match(/ipad|ipod|iphone/i)) el.setSelectionRange(0, 999999); // iOS only selects "form" elements with SelectionRange

  try {
    document.execCommand("copy"); // Security exception may be thrown by some browsers.
  } catch (ex) {
    console.warn("Copy to clipboard failed.", ex);
  }
};